import { systemColors } from "./colors";

export const boxShadow = {
  xs: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  "neo-brutal": `1px 2px 3px 1px ${systemColors["sys-black"].DEFAULT}`,
};
